import { accountantIbkApi } from '../../apiAccountantIbk';
import { clientIbkApi } from '../../apiClientIbk';
const HOME_BENEFITS_PRODUCT_URL = '/v1/home/products/beneficios';
const buildQuery = ({ document }) => ({
    url: HOME_BENEFITS_PRODUCT_URL,
    method: 'GET',
    headers: {
        'x-tr-ibk-selected-company-document': document.replace(/\D/g, ''),
    },
});
export const accountantEmissorHomeProductApi = accountantIbkApi.injectEndpoints({
    endpoints: build => ({
        getAccountantEmissorHomeBenefitsProduct: build.query({
            query: buildQuery,
            keepUnusedDataFor: 0,
        }),
    }),
});
export const clientEmissorHomeProductApi = clientIbkApi.injectEndpoints({
    endpoints: build => ({
        getClientEmissorHomeBenefitsProduct: build.query({
            query: buildQuery,
            keepUnusedDataFor: 0,
        }),
    }),
});
export const { useGetAccountantEmissorHomeBenefitsProductQuery } = accountantEmissorHomeProductApi;
export const { useGetClientEmissorHomeBenefitsProductQuery } = clientEmissorHomeProductApi;
